import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth-service';
import { UserRole } from '../../shared/model/role';

export const 


authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const userRole = localStorage.getItem('userRole');
  const requiredRole = route.data?.['role'];

  // Not logged in
  if (!authService.isLoggedIn()) {
    router.navigate(['/login']);
    return false;
  }

  // Role check
  if (requiredRole && userRole !== requiredRole) {
    return router.createUrlTree(['/']);
  }

  return true;
};
